import { axiosGet, axiosPost, axiosPostWithFile } from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL + "/weather";

export default {
  listLocalities: () => axiosGet(`${BASE_URL}/localities`),
  saveLocality: (payload) => axiosPost(`${BASE_URL}/localities/save`, payload),
  deleteLocality: (localityId, reason) => axiosPost(`${BASE_URL}/localities/delete`, { localityId, reason }),
  testLocality: (providerLocalityId) => axiosPost(`${BASE_URL}/localities/test`, { providerLocalityId }),
  listBranches: (params = {}) => axiosGet(`${BASE_URL}/branches`, params),
  saveBranchMapping: (payload) => axiosPost(`${BASE_URL}/branches/mapping`, payload),
  saveOverride: (payload) => axiosPost(`${BASE_URL}/branches/override`, payload),
  runCheck: (localityId = null) => axiosPost(`${BASE_URL}/run-check`, { localityId }),
  listAuditLogs: (params = {}) => axiosGet(`${BASE_URL}/audit-logs`, params),
  listCampaigns: () => axiosGet(`${BASE_URL}/campaigns`),
  saveCampaign: (payload) => axiosPost(`${BASE_URL}/campaigns/save`, payload),
  uploadCampaignImage: (image) => {
    const form = new FormData(); form.append("image", image);
    return axiosPostWithFile(`${BASE_URL}/campaigns/image-upload`, form);
  },
};
